import '../App.css';
import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { Redirect } from 'react-router-dom';
import * as AuthenticationUtil from "../util/AuthenticationUtil";

import { Copyright } from '../components/Copyright';

import * as Endpoints from "../util/Endpoints";
import { usePageLoader } from '../util/usePageLoader';
import { useAlert } from '../util/useAlert';

import { Logout } from '../components/Logout';
import { VaccineHistory } from '../components/VaccineHistory';

import { TableUtil } from '../util/TableUtil';
import { prepareDateTimeForText } from '../util/DateTimeUtil';
import { QuestionnaireButton } from '../components/QuestionnaireButton';

export const VaccineHistoryPage = (props) => {


        //   const api = `${Endpoints.vaccineHistory}`;
         const apis =`${Endpoints.sites}`;
      const userId = JSON.parse(localStorage.getItem("user")).id;
      const api = `${Endpoints.vaccineHistory}/${userId}`;

    const [loader, showLoader, hideLoader] = usePageLoader();
    const [alert, showAlert] = useAlert();

    const columns = [
      {
        id: "nurse",
        label: "Sjuksköterska",
        minWidth: 100,
        type: "nurseFullName",
      },

      {
        id: "vaccinatedDateTime",
        label: "Vaccinationsdatum",
        minWidth: 170,
        type: "dateTime",
      },
      { id: "vaccineBatchNumber", label: "Batchnummer ", minWidth: 100 },
      //{ id: "comment", label: "Kommentar", minWidth: 100 },
      { id: "vaccine>name", label: "Vaccin", minWidth: 100 },
      { id: "dose>quantity", label: "Dos", minWidth: 100 },
      { id: "administration>title", label: "Applikation", minWidth: 100 },
      { id: "location>title", label: "Injektionsställe", minWidth: 100 },
      { id: "sampling>title", label: "Provtagningssätt", minWidth: 100 },
      { id: "site>name", label: "Provtagningsplats", minWidth: 100 }
    ];
    console.log(api)
    console.log(apis)

    if (!AuthenticationUtil.isAuthenticated()) {
        return <Redirect to="/login" />;
    }


    return (
        <>
            <Box m={1}>
                <Grid container justifyContent="flex-end" spacing={1}>
                    <Grid item>
                        <QuestionnaireButton />
                    </Grid>
                    <Grid item>
                        <Logout />
                    </Grid>
                </Grid>


                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={11} md={10} lg={9}>
                        <Box mb={1}>
                            <h2>Vaccinationshistorik</h2>
                        </Box>
                        <TableUtil
                            api={api}
                            columns={columns}
                        />
                    </Grid>
                </Grid>
                <Grid container justifyContent="center">
                    <Grid item>
                        <Copyright />
                    </Grid>
                </Grid>
            </Box>

            {loader}
            {alert}
        </>
    );
}
